import { Pipe, PipeTransform } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
import { WizardActionSlot, WizardSlotSelection } from './model/wizard.model';

@Pipe({
  name: 'wizardSlotSelection',
  standalone: false,
})
export class WizardSlotSelectionPipe implements PipeTransform {
  transform(data: DataObject, slot: WizardActionSlot): WizardSlotSelection | null {
    return slot.formatter?.(data) ?? null;
  }
}
